import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MenuIcon, XIcon, ScrollTextIcon } from 'lucide-react';
export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Syndication',
    href: '#syndication'
  }, {
    name: 'Solutions',
    href: '#solutions'
  }, {
    name: 'Pricing',
    href: '#pricing'
  }, {
    name: 'About',
    href: '#about'
  }];
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-burgundy-950/95 backdrop-blur-md border-b border-gold-700/30 py-3 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-114">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-115">
        <a href="#" className="flex items-center gap-3 group" data-id="element-116">
          <ScrollTextIcon className="w-8 h-8 text-gold-500 group-hover:text-gold-400 transition-colors" data-id="element-117" />
          <span className="font-display text-2xl md:text-3xl font-bold text-gold-500 tracking-wider group-hover:text-gold-400 transition-colors text-shadow-gold" data-id="element-118">
            Mythicplay
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8" data-id="element-119">
          {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading text-parchment-200 hover:text-gold-400 transition-colors text-sm uppercase tracking-widest relative group" data-id="element-120">
              {link.name}
              <span className="absolute -bottom-2 left-1/2 w-0 h-px bg-gold-500 group-hover:w-full group-hover:left-0 transition-all duration-300" data-id="element-121"></span>
            </a>)}
          <a href="#contact" className="px-6 py-2 border border-gold-600 text-gold-500 font-heading uppercase tracking-widest text-sm hover:bg-gold-600/10 hover:shadow-gold-glow transition-all duration-300" data-id="element-122">
            Contact
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-gold-500 p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-123">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-124" /> : <MenuIcon className="w-6 h-6" data-id="element-125" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {isMobileMenuOpen && <motion.div initial={{
      opacity: 0,
      height: 0
    }} animate={{
      opacity: 1,
      height: 'auto'
    }} exit={{
      opacity: 0,
      height: 0
    }} className="md:hidden bg-burgundy-900 border-b border-gold-700/30" data-id="element-126">
          <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-127">
            {navLinks.map(link => <a key={link.name} href={link.href} className="font-heading text-parchment-200 hover:text-gold-400 py-2 border-b border-gold-700/20 uppercase tracking-widest text-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-128">
                {link.name}
              </a>)}
            <a href="#contact" className="font-heading text-gold-500 py-2 uppercase tracking-widest text-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-129">
              Contact
            </a>
          </div>
        </motion.div>}
    </motion.nav>;
};